import { IDanhSachLopTinChiActions } from "../../action-types/lop-tin-chi/IDanhSachLopTinChiActions";
import { eReducerStatusBase } from "../../reducer-model/eReducerStatusBase";
import { IDanhSachLopTinChiReducer } from "../../reducer-model/lop-tin-chi/IDanhSachLopTinChiReducer";
const iniState: IDanhSachLopTinChiReducer = {
    lops: []
}
export const danhSachLopTinChiReducer = (state: IDanhSachLopTinChiReducer = iniState, action: IDanhSachLopTinChiActions): IDanhSachLopTinChiReducer => {
    switch (action.type) {

        case "DANH_SACH_LOP_TC_ADD_LOP_TIN_CHI":
            return {
                ...state,
                lops: [...state.lops, {
                    id_lop_tc: action.payload,
                    status: eReducerStatusBase.is_not_initialization,
                    danhSachs: []
                }]
            }
        case "DANH_SACH_LOP_TC_LOAD_START":
            return {
                ...state,
                lops: state.lops.map(l => {
                    if (l.id_lop_tc === action.payload) {
                        return {
                            ...l,
                            status: eReducerStatusBase.is_loading
                        }
                    }
                    return l;
                })
            }
        case "DANH_SACH_LOP_TC_LOAD_SUCCESS":
            return {
                ...state,
                lops: state.lops.map(l => {
                    if (l.id_lop_tc === action.payload.id) {
                        return {
                            ...l,
                            status: eReducerStatusBase.is_completed,
                            danhSachs: action.payload.data
                        }
                    }
                    return l;
                })
            }
        case "DANH_SACH_LOP_TC_LOAD_ERROR":
            return {
                ...state,
                lops: state.lops.map(l => {
                    if (l.id_lop_tc === action.payload.id) {
                        return {
                            ...l,
                            status: eReducerStatusBase.is_completed,
                        }
                    }
                    return l;
                })
            }
        default:
            return state;
    }
}